function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 2,
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 18,
  strokeOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M36 18c0-9.94-8.06-18-18-18"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  dur: "1s",
  from: "0 18 18",
  repeatCount: "indefinite",
  to: "360 18 18",
  type: "rotate"
})));

var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    viewBox: "0 0 38 38",
    height: 32,
    width: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "54cd8d57272c18edaaabf7b7a53eda0c.svg";
export { SvgLoading as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/loading.svg
// module id = null
// module chunks = 